// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__WReQL","imageUploader":"EGiftCard_imageUploader__2zOGo"};